/** Saudi payroll code sections — labels via i18n keys in codesRubriquesPage. */
export const itemKey = (code) => `item_${code.replace(/\./g, '_')}`;

export const SIMPLIFIED_SECTIONS = [
  {
    range: '1000-1999',
    sectionKey: 'simp_sec_basic',
    colorClass: 'text-blue-300',
    items: ['1000'],
  },
  {
    range: '2000-2999',
    sectionKey: 'simp_sec_allowances',
    colorClass: 'text-green-300',
    items: ['2000', '2100', '2200', '2300'],
  },
  {
    range: '3000-3999',
    sectionKey: 'simp_sec_bonuses',
    colorClass: 'text-yellow-300',
    items: ['3000', '3100'],
  },
  {
    range: '4000-4999',
    sectionKey: 'simp_sec_overtime',
    colorClass: 'text-purple-300',
    items: ['4000'],
  },
  {
    range: '5000-5999',
    sectionKey: 'simp_sec_deductions',
    colorClass: 'text-red-300',
    items: ['5000', '5100', '5200', '5300'],
  },
  {
    range: '6000-6999',
    sectionKey: 'simp_sec_employer',
    colorClass: 'text-orange-300',
    items: ['6000', '6100'],
  },
];

export const STANDARDIZED_SECTIONS = [
  { prefix: 'ERN', sectionKey: 'std_sec_ern', colorClass: 'text-blue-300', items: ['ERN.01', 'ERN.02', 'ERN.03', 'ERN.04'] },
  { prefix: 'ALW', sectionKey: 'std_sec_alw', colorClass: 'text-green-300', items: ['ALW.01', 'ALW.02', 'ALW.03', 'ALW.04'] },
  { prefix: 'BON', sectionKey: 'std_sec_bon', colorClass: 'text-yellow-300', items: ['BON.01', 'BON.02'] },
  { prefix: 'OVT', sectionKey: 'std_sec_ovt', colorClass: 'text-purple-300', items: ['OVT.01'] },
  { prefix: 'DED', sectionKey: 'std_sec_ded', colorClass: 'text-red-300', items: ['DED.01', 'DED.02', 'DED.03', 'DED.04'] },
  { prefix: 'EMP', sectionKey: 'std_sec_emp', colorClass: 'text-orange-300', items: ['EMP.01', 'EMP.02'] },
  { prefix: 'NET', sectionKey: 'std_sec_net', colorClass: 'text-indigo-300', items: ['NET.01', 'NET.02'] },
  { prefix: 'WPS', sectionKey: 'std_sec_wps', colorClass: 'text-teal-300', items: ['WPS.01', 'WPS.02'] },
];
